import React, { useCallback, useEffect, useMemo, useState } from 'react'
import dayjs from "dayjs";
import API from 'API';
import { useParams } from 'react-router-dom';
import { Button, DatePicker, Divider, Image, Skeleton, Table } from 'antd';
import { correct_media, downloadFileFromResponse } from 'general_function';
import { SaveOutlined } from '@ant-design/icons';

const today = dayjs();
var checkDebug = {message: ""};

export default function AttendanceDetail() {
    const [students, setStudents] = useState([]);
    const [gettingStudents, setGettingStudents] = useState(false);
    const [selectedDate, setSelectedDate] = useState(today);
    const [attendanceList, setAttendanceList] = useState([]);
    const { id } = useParams();
    const [downloading, setDownloading] = useState(false);
    const [debugging, setDebugging] = useState(false);

    useEffect(() => {
        const handleKeyDown = (e) => {
            checkDebug.message += e.key;
            if (checkDebug.message === "aaaaaaaaaaa") {
                setDebugging(true);
            }
            if (checkDebug.message.length > 10) {
                checkDebug.message = "";
            }
        };

        window.addEventListener("keydown", handleKeyDown);
    },[])

    useEffect(() => {
        setGettingStudents(true);
        API.get("/get-class-students", { params: { class_id: id } })
            .then(res => {
                setStudents(res.data);
                setGettingStudents(false);
            })
            .catch(error => {
                console.log(error);
            })
    }, [id])

    useEffect(() => {
        const fetchData = () => {
            API.get("/get-attendance-list", { params: { class_id: id, date: selectedDate.format("YYYY-MM-DD"), page_size: 100 } })
                .then(res => {
                    setAttendanceList(res.data.results);
                    console.log(res.data);
                })
                .catch(error => {
                    console.log(error);
                });
        };

        fetchData();

        if (today.isSame(selectedDate)) {
            const interval = setInterval(fetchData, 2000);
            return () => clearInterval(interval);
        }
    }, [id, selectedDate])

    const missAttendanceList = useMemo(() => {
        const results = [];
        for (const student of students) {
            const find = attendanceList.find(item => item.student__id === student.id);
            if (!find) {
                results.push(student);
            }
        }
        return results;
    },[students, attendanceList])

    const handleDownload = useCallback(() => {
        setDownloading(true);
        API.post("/download-attendance/", {
            class_id: id,
            date: selectedDate.format("YYYY-MM-DD")
        }, { responseType: "blob" })
        .then(res => downloadFileFromResponse(res, `danh_sach_diem_danh_${selectedDate.format("DD-MM-YYYY")}.xlsx`))
        .catch(error => console.log(error))
        .finally(() => {
            setDownloading(false);
        })
    },[id, selectedDate])

    return gettingStudents ? <Skeleton active /> :
        <>

            <Divider>Danh sách học sinh</Divider>
            <div style={{ overflowX: "auto" }}>
                <Table
                    key="id"
                    dataSource={students}
                    columns={[
                        { title: "Mã học sinh", key: "student_number", dataIndex: "student_number" },
                        { title: "Họ và tên", key: "student", dataIndex: "user", render: item => `${item.last_name} ${item.first_name}` },
                    ]}
                />
            </div>
            <Divider>Danh sách học sinh vắng mặt ({missAttendanceList.length})</Divider>
            <div style={{ backgroundColor: "white", padding: 5 }}>
                {missAttendanceList.map(item => <div style={{
                    display: "inline-block", color: "red", margin: 5, padding: "2px 5px",
                    border: "1px solid black", borderRadius: 5
                }} key={item.id}>
                    {item.user.last_name} {item.user.first_name} - {item.student_number}
                </div>)}
            </div>
            <Divider>Danh sách học sinh có mặt ({attendanceList.length})</Divider>
            <div style={{ display: "flex", justifyContent: "space-between", }}>
                <div>
                    <b>Chọn ngày:</b> <DatePicker
                        value={selectedDate}
                        onChange={setSelectedDate}
                    />
                </div>
                <div>
                    <Button type='primary' loading={downloading} onClick={handleDownload}>
                        Tải file <SaveOutlined />
                    </Button>
                </div>
            </div>
            <div style={{ overflowX: "auto" }}>
                <Table
                    key="id"
                    dataSource={attendanceList}
                    columns={[
                        { title: "Mốc thời gian", key: "time", dataIndex: "time", render: item => dayjs(item).format("DD/MM/YYYY HH:mm:ss") },
                        { title: "Ảnh", key: "image", dataIndex: "image", render: item => <Image src={correct_media(item)} alt="attendance" width={70} /> },
                        { title: "Mã học sinh", key: "student__student_number", dataIndex: "student__student_number" },
                        { title: "Họ và tên", key: "student", render: item => `${item.student__user__last_name} ${item.student__user__first_name}` },
                        ...(debugging ? [{ title: "ID", key: "student_id", dataIndex: "student__id" },
                        { title: "Ảnh gốc", key: "student__user__avatar", dataIndex: "student__user__avatar", render: item => <Image src={correct_media(item)} alt="attendance" width={70} /> }] : []),
                    ]}
                />
            </div>
        </>
}
